<template>
  <span v-if="modo" class="produto-restricao produto-modo-pedido" :class="[`produto-modo-pedido-${modo.id}`, {'produto-modo-pedido-sacola': variant === 'sacola'}]">
    {{ modo.label }}
  </span>
</template>

<script>
export const MODOS_PEDIDO = Object.freeze({
  '2': 'Agendado',
  '3': 'Imediato'
});

export function getProdutoModoPedido(modoPedido) {
  const id = String(modoPedido || '1');
  return MODOS_PEDIDO[id] ? { id, label: MODOS_PEDIDO[id] } : null;
}

export default {
  name: 'ProdutoModoPedido',
  props: {
    modoPedido: {
      type: [String, Number],
      default: '1'
    },
    variant: {
      type: String,
      default: ''
    }
  },
  computed: {
    modo() {
      return getProdutoModoPedido(this.modoPedido);
    }
  }
};
</script>

<style scoped>
.produto-modo-pedido {
  display: inline-block;
  max-width: 100%;
  padding: 4px 6px;
  overflow: hidden;
  border-radius: 6px;
  color: #40556b;
  background-color: #e9eff4;
  font-size: 9px;
  font-weight: 600;
  line-height: 1.2;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
}

.produto-modo-pedido-sacola {
  color: #30475b;
  background-color: #d4e0e9;
}

</style>
